import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>เกี่ยวกับเรา</h1>
          <p>ทำความรู้จัก 707 M CO., LTD. ให้มากขึ้น</p>
        </div>
      </section>

      {/* Company Info Section */}
      <section className="section company-info">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="company-details">
                <h2>บริษัท 707 เอ็ม จำกัด</h2>
                <h3>707 M CO., LTD.</h3>
                <p>เราคือผู้เชี่ยวชาญด้านการนำเข้าและจำหน่ายกระติกสูญญากาศคุณภาพสูง ทั้งในตลาดประเทศและส่งออกไปยังต่างประเทศ ด้วยประสบการณ์ที่ยาวนานในอุตสาหกรรมการผลิตภาชนะบรรจุภัณฑ์และเครื่องใช้บนโต๊ะอาหารที่ทำจากแก้ว</p>
                <p>บริษัทของเรามุ่งมั่นในการให้บริการลูกค้าด้วยผลิตภัณฑ์คุณภาพสูง ที่ผ่านการควบคุมมาตรฐานทุกขั้นตอน พร้อมทั้งให้คำแนะนำและบริการหลังการขายที่ดีเยี่ยม</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="company-image">
                <img src="/images/vacuum-flask-3.jpg" alt="707 M CO., LTD. - บริษัทของเรา" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Business Details Section */}
      <section className="section business-details bg-light">
        <div className="container">
          <div className="section-title">
            <h2>ข้อมูลธุรกิจ</h2>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="business-info-card">
                <h3>ข้อมูลบริษัท</h3>
                <ul>
                  <li><strong>ทะเบียน:</strong> 0105567253957</li>
                  <li><strong>จดทะเบียน:</strong> 23 ธันวาคม 2567</li>
                  <li><strong>ทุนจดทะเบียน:</strong> 3,000,000 บาท</li>
                  <li><strong>สถานะ:</strong> ยังดำเนินกิจการอยู่</li>
                </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div className="business-info-card">
                <h3>ประเภทธุรกิจ</h3>
                <ul>
                  <li><strong>หมวดธุรกิจ:</strong> การขายส่งสินค้าทั่วไปโดยได้รับค่าตอบแทนหรือตามสัญญาจ้าง</li>
                  <li><strong>ธุรกิจ:</strong> สั่งเข้ามาจำหน่ายในประเทศและส่งออกไปจำหน่ายยังต่างประเทศ</li>
                  <li><strong>ผลิตภัณฑ์หลัก:</strong> จำหน่ายกระติกสูญญากาศ</li>
                  <li><strong>หมวดอุตสาหกรรม:</strong> การผลิตภาชนะบรรจุภัณฑ์และเครื่องใช้บนโต๊ะอาหารที่ทำจากแก้ว</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Address Section */}
      <section className="section address-section">
        <div className="container">
          <div className="section-title">
            <h2>ที่อยู่ของเรา</h2>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="address-card">
                <h3>สำนักงานใหญ่</h3>
                <p>968 อาคารอื้อจือเหลียง ชั้นที่ 5 ถนนพระรามที่ 4 แขวงสีลม เขตบางรัก กรุงเทพมหานคร 10500</p>
                <div className="contact-info">
                  <p><strong>โทรศัพท์:</strong> +66 2 234 5678</p>
                  <p><strong>อีเมล:</strong> info@707m.co.th</p>
                </div>
                <Link to="/contact" className="btn btn-primary mt-3">ติดต่อเรา</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="section mission-vision bg-light">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="mission-card">
                <h3>พันธกิจของเรา</h3>
                <p>เรามุ่งมั่นในการให้บริการลูกค้าด้วยผลิตภัณฑ์คุณภาพสูง ที่ตอบโจทย์ความต้องการของลูกค้าทั้งในประเทศและต่างประเทศ พร้อมทั้งเป็นผู้นำในอุตสาหกรรมการผลิตภาชนะบรรจุภัณฑ์และเครื่องใช้บนโต๊ะอาหารที่ทำจากแก้ว</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="vision-card">
                <h3>วิสัยทัศน์ของเรา</h3>
                <p>เรามีวิสัยทัศน์ที่จะเป็นบริษัทชั้นนำในการจำหน่ายกระติกสูญญากาศและผลิตภัณฑ์ที่เกี่ยวข้อง ที่มีคุณภาพสูงและได้รับการยอมรับในระดับสากล พร้อมทั้งขยายตลาดไปยังประเทศต่างๆ ทั่วโลก</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
